

<template>
  <div class="homeMain">
    <homehead :headData="public_da.header_data" :changeLanguage="changeLanguage"></homehead>
    <intro :introData="public_da.intro_data"></intro>
    <product :serviceData="public_da.services_data" :productData="public_da.product_data"></product>
    <news :newsData="public_da.news_data"></news>
    <about :aboutData="public_da.about_data" :recruitData="public_da.recruit_data"></about>
    <contact :contactData="public_da.contact_data"></contact>
    <homefoot :footerData="public_da.footer_data"></homefoot>
    <!-- <h1>{{ msg }}</h1>
    <h2>Essential Links</h2> -->
   <div id="scroll-top-div" class="scroll-top-div">
        <div class="scroll-top-icon-container">
          <i class="ion-ios-arrow-thin-up"></i>
        </div>
   </div>
  </div>
</template>

<script>
import homehead from '@/components/header'
import homefoot from '@/components/footer'
import intro from '@/components/intro'
import product from '@/components/product'
import about from '@/components/about'
import contact from '@/components/contact'
import news from '@/components/news'

import publicData from '@/publicData.js'
export default {
  name: 'home',
  components: {
    homehead,
    homefoot,
    intro,
    product,
    about,
    contact,
    news
  },
  data () {
    return {
      public_da_raw: publicData,
      language: 'data_cn'
    }
  },
  mounted: function() {

  },
  computed: {
    public_da: function () {
      let tmp = this.language
      return this.public_da_raw[tmp]
    }
  },
  methods: {
    changeLanguage: function() {
      if(this.language === 'data_cn') {
        this.language = 'data_en'
        } else {
        this.language = 'data_cn'
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue